import styled from 'styled-components';

import { colors, smallShadow, spacing } from 'ui/theme';
import { useAnimatedPositionTransition } from 'utils/hooks/useAnimatedPositionTransition';

import { ExtendedChannel } from '../../types';
import { MessageTypesTable } from './MessageTypesTable';
import { Title } from './Title';

const Wrapper = styled.li`
  margin-bottom: ${spacing.double};
  background-color: ${colors.white};
  border-radius: ${spacing.half};
  overflow: hidden;
  ${smallShadow}

  &:last-of-type {
    margin-bottom: 0;
  }
`;

type ChannelSubscriptionSettingProps = {
  channel: ExtendedChannel;
};

export const ChannelSubscriptionSetting = ({ channel }: ChannelSubscriptionSettingProps) => (
  <Wrapper
    ref={useAnimatedPositionTransition()}
    data-test={`channel-table-${channel.messageMedium}`}
  >
    <Title channel={channel} />
    <MessageTypesTable channelId={channel.id} />
  </Wrapper>
);
